import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

export default defineNuxtPlugin(async (nuxtApp) => {
  let defaultCountry = 'EG';

  if (import.meta.client) {
    try {
      // Use cached value if available
      const cached = localStorage.getItem('user_country');
      if (cached) {
        defaultCountry = cached;
      } else {
        const res = await fetch('https://ipapi.co/json/');
        if (!res.ok) throw new Error('geo failed');
        const data = await res.json();
        if (data?.country_code) {
          defaultCountry = data.country_code;
          localStorage.setItem('user_country', data.country_code); // 👈 cache it
        }
      }
    } catch {
      // fallback to 'EG'
    }
  }

  nuxtApp.vueApp.use(VueTelInput, {
    mode: 'international',
    autoFormat: false,
    defaultCountry,

    inputOptions: {
      showDialCode: true,
      placeholder: 'Enter your phone number',
    },

    dropdownOptions: {
      showFlags: true,
      showDialCodeInList: false,
      showDialCodeInSelection: false,
      showSearchBox: true,
    },
  });
});
